import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router/router'
import { createPinia } from 'pinia'
/* Plugins */
import i18n from '@/assets/setups/i18n'
import vClickOutside from 'click-outside-vue3'
import inputMask from '@/assets/localPlugins/inputMask/inputmaskSetup'
import { dragscrollNext } from 'vue-dragscroll'
import AmountFormatInputInstall from 'vue-format-amount-input'
import Vue3TouchEvents from 'vue3-touch-events'

if (import.meta.env.VITE_INCLUDE_RETAIL_CSS === 'true') {
	import('@/styles/themesRetail.scss').then(themesRetail => {
		// themesRetail.init() not sure why but this always gives an error and this works without this
	})
}

if (import.meta.env.VITE_INCLUDE_CORPORATE_CSS === 'true') {
	import('@/styles/themesCorporate.scss').then(themesCorporate => {
		// themesCorporate.init() not sure why but this always gives an error and this works without this
	})
}

const app = createApp(App)
app.use(i18n)
app.use(createPinia())
app.use(router)
app.use(vClickOutside)
app.use(inputMask)
app.use(AmountFormatInputInstall)
app.directive('dragscroll', dragscrollNext)
app.use(Vue3TouchEvents)
app.mount('#app')

/* NOTE, to allow warnings comment this handler */
app.config.warnHandler = function (msg, vm, trace) {
	// console.warn(msg, vm, trace)
}
